import React from 'react'
import { Skeleton } from 'antd'
import Container from './styles'

const CompanyListItem = ({ loading, company_name, company_email, contact_person, contact_phone, status, onClick }) => {
  return (
    <Container onClick={onClick}>
      {loading ? (
        <Skeleton active />
      ) : (
        <>
          <div className="company--info">
            <div className="company--avatar" >
              {company_name ? company_name[0].toUpperCase() : 'C'}
            </div>
            <div className="company--details">
              <h3>{company_name}</h3>
              <p className="email">{company_email}</p>
              <p className="contact">
                <strong>Contact:</strong> {contact_person} - {contact_phone}
              </p>
            </div>
          </div>
          <div className={`status--badge ${status?.toLowerCase()}`}>
            {status || 'ACTIVE'}
          </div>
        </>
      )}
    </Container>
  )
}

export default CompanyListItem
